module.exports = "<p>\n  housekeeping works!\n</p>\n"